import React from 'react';
import { Button } from 'system/atoms';
import { useModalV2 } from 'common/modal/hooks/useModalV2';

type Props = {
  onClearRequirements: () => void;
};

export const AnalyseClearRequirementsButton: React.FC<Props> = ({
  onClearRequirements
}) => {
  const { openModal } = useModalV2();

  const handleClearRequirements = () => {
    openModal({
      title: 'Clear requirements?',
      subtitle:
        'All requirements will be deleted immediately. This cannot be undone.',
      primaryButtonText: 'Cancel',
      secondaryButtonText: 'Delete',
      primaryButtonProps: { variant: 'primary' },
      secondaryButtonProps: { variant: 'tertiary', state: 'destructive' },
      onSecondaryAction: onClearRequirements // Delete action
    });
  };

  return (
    <Button
      variant="tertiary"
      state="destructive"
      onClick={handleClearRequirements}
    >
      Clear requirements
    </Button>
  );
};
